import { api } from './http';

// eslint-disable-next-line
export const dadosCEP = cep => api.get(`/utils/cep/${cep}`);
export const contato = dados => api.post('/utils/contact', dados);
